export const COLOR_TRANSPARENT = 'rgba(0,0,0,0)'
export const COLOR_WHITE = '#fff'
export const CHART_TEXT_COLOR = '#8698aa'
export const CHART_POSITIVE_COLOR = '#01b292'
export const CHART_NEGATIVE_COLOR = '#ff6867'
export const CHART_POSITIVE_DARKEN_COLOR = '#196761'
export const CHART_NEGATIVE_DARKEN_COLOR = '#89434d'

export const CHART_COLOR_OVERRIDES = {
  'mainSeriesProperties.candleStyle.upColor': CHART_POSITIVE_COLOR,
  'mainSeriesProperties.candleStyle.downColor': CHART_NEGATIVE_COLOR,
  'mainSeriesProperties.candleStyle.borderUpColor': CHART_POSITIVE_COLOR,
  'mainSeriesProperties.candleStyle.borderDownColor': CHART_NEGATIVE_COLOR,
  'mainSeriesProperties.candleStyle.wickUpColor': CHART_POSITIVE_COLOR,
  'mainSeriesProperties.candleStyle.wickDownColor': CHART_NEGATIVE_COLOR,
  'paneProperties.background': '#121b31',
  'paneProperties.backgroundType': 'solid',
  'paneProperties.vertGridProperties.color': COLOR_TRANSPARENT,
  'paneProperties.horzGridProperties.color': COLOR_TRANSPARENT,
  'paneProperties.crossHairProperties.color': COLOR_WHITE,
  'scalesProperties.lineColor': CHART_TEXT_COLOR,
  'scalesProperties.textColor': CHART_TEXT_COLOR
}
